<template>
  <div class="wizard-container">
    <div class="progress-bar-container" v-if="savingSurveyInProgress">
      <label v-html="savingProgressContent"></label><br/>
      <progress-bar :options="ProgressBarOptions" :value="progressBarValue" />
    </div>
    <form data-vv-scope="add-survey" v-if="$store.state.userData.role =='super-admin' || $store.state.settings.enable_survey_feature == 1">
      <form-wizard @on-complete="surveySaved" @on-error="handleErrorMessage" title="Create Survey" subtitle="" shape="tab" back-button-text="Back!" next-button-text="Next!" finish-button-text="Submit" color="#82DE6D" v-if="$store.state.userData.role =='super-admin' || $store.state.userData.surveyFeature == 1">
          <!-- basic survey details tab -->
          <tab-content title="Basic Details" icon="ti-align-justify" :before-change="checkBasicDetailsValidation" >
            <BasicSurveyDetails :basicSurveyDetails="basicSurveyDetails" @basicDetailsUpdated="updateSurveyBasicDetails" :surveyId="surveyId"/>
          </tab-content>
          <!-- questions and answers details tab -->
          <tab-content title="Add Questions" icon="ti-settings" :before-change="checkQuestionAnswersValidateion">
            <span class="localstorage-existing-data-notice" v-if="QuestionDataExistsInLocalStorage">You have unsaved changes in your brwoser, click <a href="javascript:;" @click="fillLocalStorageQuestioncDetails">here</a> to prefill those!</span>

            <QuestionBuilder
              v-for="(question, qi) in surveyQuestionAnswers"
              :key="'root-' + qi"
              :question="question"
              :questionIndex="qi"
              :questionPath="[qi]"
              :parentPath="[]"
              :level="0"
              :basicSurveyDetails="basicSurveyDetails"
              :errors="errors"
              :validator="$validator"
              @remove-question="removeQuestion"
              @add-answer="addAnswerToQuestion"
              @remove-answer="removeAnswer"
              @add-followup="addFollowUpQuestion"
              @remove-followup="removeFollowUpQuestion"
            />

            <a href="javascript:;" class="add-question-button" @click="AddQuestion" v-if="basicSurveyDetails.type == 'MEDIA' && surveyQuestionAnswers.length < this.$store.state.settings.max_questions_per_media_survey">+  Question</a>
            <a href="javascript:;" class="add-question-button" @click="AddQuestion" v-if="basicSurveyDetails.type == 'PICKL' && surveyQuestionAnswers.length < this.$store.state.settings.max_questions_per_survey">+  Question</a>
            <a href="javascript:;" class="add-question-button" @click="AddQuestion" v-if="basicSurveyDetails.type == 'NON_GEO' && surveyQuestionAnswers.length < this.$store.state.settings.max_questions_per_non_geo_survey">+  Question</a>
          </tab-content>

          <!-- reivew survey tab -->
          <tab-content title="Review" icon="ti-eye" :before-change="submitForm">
            <ReviewSurvey :basicSurveyDetails="basicSurveyDetails" :surveyQuestionAnswers="surveyQuestionAnswers" />
          </tab-content>
      </form-wizard>
      <div v-else>
          <h2 style="text-align:center;">This feature is only available for <strong>Essentials</strong> & <strong>Pro</strong> plans<br/>click <router-link to="/brand/subscription"> <strong class="upgrade-link">Here</strong></router-link> to upgrade your plan</h2>
      </div>
    </form>
    <h2 v-else style="text-align:center;">Survey Feature is not available for you!</h2>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import BasicSurveyDetails from '@/components/common/Survey/BasicDetails'
import ReviewSurvey from '@/components/common/Survey/ReviewSurvey'
import QuestionBuilder from '@/components/common/Survey/QuestionBuilder'
import { stringify } from '@amcharts/amcharts4/.internal/core/utils/Utils'
import ProgressBar from 'vuejs-progress-bar'

export default {
  data () {
    return {
      surveyId: this.$route.params.surveyId,
      SurveyDetailsDuringSaving: [],
      savingProgressContent: '',
      savingSurveyInProgress: false,
      progressBarValue: 0,
      ProgressBarOptions: {
        text: {},
        progress: {
          color: '#43DB6D',
          backgroundColor: '#782B55'
        },
        layout: {
          width: '500',
          height: '30'
        }
      },
      brandId: 0,
      QuestionDataExistsInLocalStorage: false,
      basicSurveyDetails: {
        title: '',
        description: '',
        type: '',
        surveyType: ''
      },
      surveyQuestionAnswers: []
    }
  },
  name: 'CreateSurvey',
  components: {
    FormWizard,
    TabContent,
    BasicSurveyDetails,
    ProgressBar,
    ReviewSurvey,
    QuestionBuilder
  },
  methods: {
    surveySaved () {},

    async submitForm () {
      window.scrollTo(0, 0)
      await this.saveSurvey()
      return true
    },

    // ✅ FIXED saveSurvey function
    async saveSurvey () {
      this.basicSurveyDetails = JSON.parse(localStorage.getItem('SurveyBasicDetails'))
      let action = 'saveSurvey'
      this.savingSurveyInProgress = true

      let survey = {
        id: this.basicSurveyDetails.id,
        brandId: this.brandId,
        description: this.basicSurveyDetails.description,
        type: this.basicSurveyDetails.type,
        title: this.basicSurveyDetails.title,
        surveyType: this.basicSurveyDetails.surveyType,
        userId: this.$store.state.userData.id,
        status: 'ACTIVE'
      }

      let context = 'Saving'
      if (typeof survey.id !== 'undefined' && survey.id !== null) {
        action = 'updateSurvey'
        context = 'Updating'
      }

      this.savingProgressContent = `${context} Survey...`

      try {
        const response = await this.$store.dispatch(action, survey)

        // ✅ handle actual API response format (your example)
        if (response && response.id) {
          survey.id = response.id
          this.basicSurveyDetails.id = response.id
        }

        // ✅ Store basic details back to local storage
        localStorage.setItem('SurveyBasicDetails', stringify(this.basicSurveyDetails))

        // ✅ Get questions
        const questions = JSON.parse(localStorage.getItem('SurveyQuestionDetails')) || []
        const totalSteps = this.countTotalQuestions(questions) + 1
        let i = 1

        for (const question of questions) {
          this.savingProgressContent = `Saving Question ${i} of ${questions.length}`
          await this.saveQuestion(question, survey, i - 1)
          i++
          this.progressBarValue = Math.round((i / totalSteps) * 100)
        }

        this.savingProgressContent = 'Survey Saved Successfully!'
        this.savingSurveyInProgress = false

        // ✅ Clear storage
        localStorage.removeItem('SurveyQuestionDetails')
        localStorage.removeItem('SurveyBasicDetails')

        // ✅ Redirect
        if (this.$store.state.userData.role === 'brand') {
          this.$router.push('/brand/insights')
        } else if (this.$store.state.userData.role === 'super-admin') {
          this.$router.push(`/sadmin/insights/${this.brandId}`)
        }

        // ✅ Notify
        this.$notify({
          type: 'success',
          text: 'Insight has been saved successfully!'
        })
      } catch (error) {
        console.error('Error saving survey:', error)
        this.$notify({
          type: 'error',
          text: 'Something went wrong while saving the survey.'
        })
        this.savingSurveyInProgress = false
      }
    },
    // ✅ helper function to count total questions (if not already in file)
    countTotalQuestions (questions) {
      let count = 0
      for (const question of questions) {
        count++
        if (question.answers && question.answers.length) {
          for (const answer of question.answers) {
            if (answer.followUpQuestions && answer.followUpQuestions.length) {
              count += this.countTotalQuestions(answer.followUpQuestions)
            }
          }
        }
      }
      return count
    },

    async saveQuestion (question, survey, questionIndex, parentQuestionId = null, parentAnswerId = null) {
      let action = 'saveQuestion'
      let data = {
        id: question.id,
        question: question.question,
        questionType: question.questionType,
        parentAnswer: question.parentAnswer,
        status: 'ACTIVE',
        surveyId: survey.id,
        userId: this.$store.state.userData.id,
        brandId: this.brandId,
        parentQuestionId: parentQuestionId,
        parentAnswerId: parentAnswerId
      }
      if (typeof data.id !== 'undefined') {
        action = 'updateQuestion'
      }
      let response = await this.$store.dispatch(action, data).then((response) => { return response })
      if (response && (response.status === 200 || response.status === 204 || response.id)) {
        this.SurveyDetailsDuringSaving = JSON.parse(localStorage.getItem('SurveyQuestionDetails'))
        if (response.id) {
          if (!parentQuestionId) {
            this.SurveyDetailsDuringSaving[questionIndex].id = response.id
          }
          question.id = response.id
        }
        localStorage.setItem('SurveyQuestionDetails', stringify(this.SurveyDetailsDuringSaving))
        let answerIndex = 0
        if (question.questionType !== 'TEXT') {
          for (const answer of question.answers) {
            await this.saveAnswer(answer, question, survey, questionIndex, answerIndex, parentQuestionId !== null)
            answerIndex++
          }
        }
      }
      return response
    },

    async saveAnswer (answer, question, survey, questionIndex, answerIndex, isFollowUp = false) {
      let action = 'saveAnswer'
      let data = {
        id: answer.id,
        answerOption: answer.answerOption,
        questionId: question.id,
        status: 'ACTIVE',
        surveyId: survey.id,
        userId: this.$store.state.userData.id,
        brandId: this.brandId
      }
      if (typeof data.id !== 'undefined') {
        action = 'updateAnswer'
      }
      let response = await this.$store.dispatch(action, data).then((response) => { return response })
      if (response && (response.status === 200 || response.status === 204 || response.id)) {
        this.SurveyDetailsDuringSaving = JSON.parse(localStorage.getItem('SurveyQuestionDetails'))
        if (response.id) {
          if (!isFollowUp) {
            this.SurveyDetailsDuringSaving[questionIndex].answers[answerIndex].id = response.id
          }
          answer.id = response.id
        }
        localStorage.setItem('SurveyQuestionDetails', stringify(this.SurveyDetailsDuringSaving))
        if (answer.followUpQuestions && answer.followUpQuestions.length > 0) {
          for (let fqi = 0; fqi < answer.followUpQuestions.length; fqi++) {
            const followUpQuestion = answer.followUpQuestions[fqi]
            await this.saveQuestion(followUpQuestion, survey, fqi, question.id, answer.id)
          }
        }
      }
      return response
    },

    checkBasicDetailsValidation () {
      if (this.basicSurveyDetails.title !== '' & this.basicSurveyDetails.description !== '' & this.basicSurveyDetails.type !== '' & this.basicSurveyDetails.surveyType !== '') {
        localStorage.setItem('SurveyBasicDetails', stringify(this.basicSurveyDetails))
        return true
      } else {
        return false
      }
    },
    updateSurveyBasicDetails (basicDetails) {
      this.basicSurveyDetails = basicDetails
    },

    AddQuestion () {
      this.surveyQuestionAnswers.push({
        question: '',
        questionType: '',
        answers: [
          { answerOption: '', followUpQuestions: [] },
          { answerOption: '', followUpQuestions: [] }
        ]
      })
    },

    removeQuestion (index, questionId) {
      this.surveyQuestionAnswers.splice(index, 1)
      if (typeof questionId !== 'undefined') {
        this.$store.dispatch('deleteSurveyQuestion', { brandId: this.brandId, surveyId: this.surveyId, questionId: questionId })
      }
    },

    addAnswerToQuestion (data) {
      const path = data.path || data
      this.getQuestionByPath(path).answers.push({ answerOption: '', followUpQuestions: [] })
    },
    removeAnswer (data) {
      const { questionPath, answerIndex } = data
      this.getQuestionByPath(questionPath).answers.splice(answerIndex, 1)
    },
    addFollowUpQuestion (data) {
      const { questionPath, answerIndex } = data
      const question = this.getQuestionByPath(questionPath)
      if (!question.answers[answerIndex].followUpQuestions) {
        question.answers[answerIndex].followUpQuestions = []
      }
      question.answers[answerIndex].followUpQuestions.push({
        question: '',
        questionType: '',
        answers: [
          { answerOption: '', followUpQuestions: [] },
          { answerOption: '', followUpQuestions: [] }
        ]
      })
    },
    removeFollowUpQuestion (data) {
      const { questionPath, answerIndex, followUpIndex } = data
      const question = this.getQuestionByPath(questionPath)
      question.answers[answerIndex].followUpQuestions.splice(followUpIndex, 1)
    },
    getQuestionByPath (path) {
      let current = this.surveyQuestionAnswers[path[0]]
      for (let i = 1; i < path.length; i += 3) {
        const answerIdx = path[i]
        const followUpIdx = path[i + 1]
        if (current.answers && current.answers[answerIdx]) {
          if (followUpIdx !== undefined && current.answers[answerIdx].followUpQuestions) {
            current = current.answers[answerIdx].followUpQuestions[followUpIdx]
          }
        }
      }
      return current
    },
    checkQuestionAnswersValidateion () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('add-survey').then((result) => {
          if (result) {
            localStorage.setItem('SurveyQuestionDetails', stringify(this.surveyQuestionAnswers))
            resolve(true)
          } else {
            this.$notify({ type: 'error', text: 'Please fill all fields before proceeding!' })
            reject(this.handleErrorMessage('error'))
          }
        })
      })
    },
    handleErrorMessage (errMsg) {},
    checkLocalStorageForQuestionDetails () {
      let localStorageQuestionDetails = localStorage.getItem('SurveyQuestionDetails')
      if (localStorageQuestionDetails !== null) {
        this.QuestionDataExistsInLocalStorage = true
      }
    },
    fillLocalStorageQuestioncDetails () {
      let data = JSON.parse(localStorage.getItem('SurveyQuestionDetails'))
      this.surveyQuestionAnswers = data
      this.QuestionDataExistsInLocalStorage = false
    },
    getSurveyById () {
      this.$store.dispatch('getSurveyById', { brandId: this.brandId, surveyId: this.surveyId }).then((response) => {
        this.basicSurveyDetails = {
          id: response.response.body.id,
          title: response.response.body.title,
          description: response.response.body.description,
          type: response.response.body.type,
          surveyType: response.response.body.survey_type
        }

        const questions = response.response.body.survey_questions || []
        const questionIdToNode = {}

        for (const question of questions) {
          const normalizedParentQuestionId = (question.parent_question_id != null ? question.parent_question_id : question.parent_question) != null
            ? Number(question.parent_question_id != null ? question.parent_question_id : question.parent_question)
            : null
          const normalizedParentAnswerId = question.parent_answer != null ? question.parent_answer : null
          const normalizedParentAnswer = question.parent_answer != null ? String(question.parent_answer) : ''

          const answersArray = []
          const rawAnswers = question.survey_question_answers || []
          for (const answer of rawAnswers) {
            answersArray.push({ id: Number(answer.id), answerOption: answer.answer_option, followUpQuestions: [] })
          }
          questionIdToNode[question.id] = {
            id: Number(question.id),
            question: question.question,
            questionType: question.question_type,
            parentAnswer: normalizedParentAnswer,
            parentQuestionId: normalizedParentQuestionId,
            parentAnswerId: normalizedParentAnswerId,
            answers: answersArray
          }
        }

        const roots = []
        for (const q of Object.values(questionIdToNode)) {
          if (!q.parentQuestionId || q.parentQuestionId === 0) {
            roots.push(q)
            continue
          }

          const parentNode = questionIdToNode[q.parentQuestionId]
          if (!parentNode || !parentNode.answers || parentNode.answers.length === 0) {
            roots.push(q)
            continue
          }

          let attached = false
          if (q.parentAnswerId) {
            for (const ans of parentNode.answers) {
              if (Number(ans.id) === Number(q.parentAnswerId)) {
                if (!ans.followUpQuestions) ans.followUpQuestions = []
                ans.followUpQuestions.push(q)
                attached = true
                break
              }
            }
          }

          if (!attached && q.parentAnswer) {
            for (const ans of parentNode.answers) {
              if ((ans.answerOption || '').toString().trim() === (q.parentAnswer || '').toString().trim()) {
                if (!ans.followUpQuestions) ans.followUpQuestions = []
                ans.followUpQuestions.push(q)
                attached = true
                break
              }
            }
          }

          if (!attached) {
            roots.push(q)
          }
        }

        roots.sort((a, b) => a.id - b.id)
        this.surveyQuestionAnswers = roots
      })
    }
  },
  mounted () {
    this.surveyName = localStorage.surveyName
    this.surveyDescription = localStorage.surveyDescription
    this.checkLocalStorageForQuestionDetails()
    this.getSurveyById()
  },
  created () {
    if (this.$store.state.userData.role === 'super-admin') {
      this.brandId = this.$route.params.brandId
    } else {
      this.brandId = this.$store.state.userData.brandId
    }
    this.$store.dispatch('getAppSettingsKeyValuePair')
  }
}
</script>

<style scoped>
.wizard-container {
  width:70%;
  margin:auto;
  border: solid 2px rgb(130, 222, 109);
  padding:1%;
  border-radius:20px;
}
select,
select:hover {
  border: 1px solid #6f3053;
  border-radius: 3px;
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 20px;
  color: black;
  width: 100%;
  padding: 14px 42px 14px 16px;
  height: 50px;
  background-position: right 11px center;
  background-size: 20px 12px;
  background-image: url("/img/Create Pickl/selectproductDropdown_icon.png");
  background-color: white;
}
.answer-input {
  height: 30px;
  border-radius: 10px;
  margin:0;
  width:90%;
}
.add-more-ans {
  font-size: 15px;
  text-decoration: none;
  display: block;
  margin-left: 3%;
}
.single-quesion-box {
  border: solid 1px rgb(130, 222, 109);
  padding:1%;
  border-radius:20px;
  margin: 10px;

}
.add-question-button {

  border: solid 1px rgb(130, 222, 109);
  color: black;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15px;
  display: block;
  width: 20%;
  text-align: center;
  padding: 1%;
  border-radius: 10px;
}
a {
  color:#782b54;
}
.delete-question-link {
  font-size:16px;
  margin-top:40px;
}
.answer-container {
  margin-left: 2%;
  margin:1%;
}
.remove-answer-button {
  background: #782b54;
  height: 35px;
  border: none;
  border-radius: 150px;
  color: white;
  padding: 3px 10px 0px 10px;
}
.localstorage-existing-data-notice {
    text-align: center;
    display: block;
    color: black;
    font-size: 16px;
    margin-bottom: 10px;
    transition: opacity cubic-bezier(0, 0.52, 1, 1) 1s
  }
  .progress-bar-container {
    width: 60%;
    margin: auto;
  }
@media only screen and (max-width: 1024px) {
  .wizard-container {
    width:100%;
    margin:auto;
    border: solid 2px rgb(130, 222, 109);
    padding:1%;
    border-radius:20px;
  }

}
</style>
